export default "__VITE_ASSET__beb7f236__"